export default function () {
  const windowWidth = window.innerWidth;
  const bodyWidth = document.body.offsetWidth;
  document.body.style.setProperty(
    "--scrollbarWidth",
    windowWidth - bodyWidth + "px"
  );
}
